@if (survey) {
  <div class="container-fluid mb-5">
    <div class="dashboard-card shadow-sm my-4 border-primary">
      @if (surveyIsPrivate) {
        <div class="card-header bg-white border-bottom p-4 card-header-top">
          <div class="row align-items-start">
            <div class="col-md-7">
              <h4 class="dashboard-card-title text-primary-purple mb-1 d-flex align-items-center">
                <fa-icon [icon]="faClipboardList" class="dashboard-title-icon"></fa-icon>
                {{ 'components.responses.responses' | translate }}
              </h4>
              <p class="text-muted mb-4">View submitted answers, track response rates, and manage when participants can submit.</p>
              <div class="d-flex stats-row">
                <div class="stat-item mr-5">
                  <h2 class="mb-0 font-weight-bold text-primary-purple">{{ survey?.members?.length || 0 }}</h2>
                  <small class="stat-label">{{ "generic.total-members" | translate }}</small>
                </div>
                <div class="stat-item mr-5">
                  <h2 class="mb-0 font-weight-bold text-info">{{ participantsCount }}</h2>
                  <small class="stat-label">{{ "generic.participants" | translate }}</small>
                </div>
                <div class="stat-item mr-5">
                  <h2 class="mb-0 font-weight-bold text-success">{{ answersSent?.length }}</h2>
                  <small class="stat-label">{{ "components.responses.responses" | translate }}</small>
                </div>
              </div>
            </div>
            @if (chartOptions) {
              <div class="col-md-5 d-flex justify-content-end">
                <div class="chart-wrapper" style="height: 200px; width: 100%; max-width: 280px;">
                  <div echarts [options]="chartOptions" style="height: 100%; width: 100%;"></div>
                </div>
              </div>
            }
          </div>
        </div>
      }
      <div class="card-body p-0">
        <div class="row justify-content-center card-details-buttons">
          <div class="col-12 d-flex justify-content-between align-items-center">
            <div class="response-label-container">
              @if (survey?.answers_sent === 0) {
                <span class="text-muted">{{ 'pages.surveys.responses.no-responses' | translate }}</span>
              }
            </div>
            @if (!survey?.is_revised) {
              <div class="d-flex align-items-center">
                @if (survey?.answers_sent > 0) {
                  <button mat-stroked-button color="primary" class="mr-3 d-flex align-items-center" (click)="exportAllResponses()" [disabled]="loading">
                    <mat-icon class="mr-2">get_app</mat-icon>
                    {{ "generic.export-survey-results" | translate }}
                  </button>
                }
                <mat-button-toggle-group name="survey_status" [(ngModel)]="survey.status" (ngModelChange)="onChangeStatus($event)"
                  [hideMultipleSelectionIndicator]="true"
                  [hideSingleSelectionIndicator]="true"
                  style="height: 38px; align-items: center;">
                  <mat-button-toggle
                    [value]="'EVALUATING'"
                    [ngClass]="{'bg-success text-white': survey.status === 'EVALUATING'}">
                    {{ "generic.accept-answers" | translate }}
                  </mat-button-toggle>
                  <mat-button-toggle
                    [value]="'CLOSED'"
                    [ngClass]="{'bg-danger text-white': survey.status === 'CLOSED'}">
                    {{ "generic.block-answers" | translate }}
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            }

          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (loading) {
  <div class="my-4">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

@if (survey?.answers_sent > 0 && questions?.length > 0 && !loading) {
  <div class="mt-5">
    @if (tabIndex == 0) {
      @for (question of questions; track question; let i = $index) {
        <div
          class="container-fluid accordion-container mt-3 accordion-inner"
          >
          <mat-accordion class="accordion" multi >
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header class="py-2">
                <mat-panel-title>
                  <span>{{ question.question }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <!-- <pre>{{ question | json }}</pre> -->
              <div class="container">

                @if (question?.description) {
                  <div class="alert alert-info my-3 mx-3 d-flex align-items-start" role="alert">
                    <mat-icon class="alert-info-icon flex-shrink-0 mr-2">info</mat-icon>
                    <div>
                      <strong>{{ 'generic.description' | translate }}:</strong> {{ question.description }}
                    </div>
                  </div>
                }
                <app-single-question-responses
                  [question]="question"
                  [showPrivateInfo]="showPrivateInfo"
                  [surveyId]="surveyId"
                  (aiAnalysisCompleted)="onAiAnalysisCompleted()"
                />
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      }
      <mat-paginator
        class="mt-5 paginator-rounded"
        [length]="totalQuestions"
        [pageSize]="pageSize"
        [pageIndex]="currentPageIndex"
        [pageSizeOptions]="[1, 5, 10]"
        (page)="onPageChange($event)">
      </mat-paginator>
    }
    @if (tabIndex == 1) {
    }
    @if (tabIndex == 2) {
    }
  </div>
}

@if (survey?.answers_sent > 0 && !survey?.customs?.anonymous_survey) {
  <div class="anonymize-button" (click)="toggleAnonymousData()">
    @if (showPrivateInfo) {
      <span>{{ 'generic.hide-private-data' | translate }}</span>
    }
    @if (!showPrivateInfo) {
      <span>{{ 'generic.show-private-data' | translate }}</span>
    }
  </div>
}
